import { useState, useEffect } from 'react';
import { useApi, githubAuthApiRef } from '@backstage/core-plugin-api';
import yaml from 'js-yaml';
import { fetchFileContent } from '../shared';
import { BusinessUnit, BusinessUnitCatalog } from './types';

interface UseBusinessUnitsResult {
  businessUnits: BusinessUnit[];
  loading: boolean;
  error: string | null;
}

export function useBusinessUnits(
  owner: string,
  repo: string,
  path: string,
  ref?: string,
): UseBusinessUnitsResult {
  const [businessUnits, setBusinessUnits] = useState<BusinessUnit[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const githubAuth = useApi(githubAuthApiRef);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      setError(null);
      try {
        const token = await githubAuth.getAccessToken(['repo']);
        const text = await fetchFileContent(token, owner, repo, path, ref);
        const parsed = yaml.load(text) as BusinessUnitCatalog;
        if (parsed?.business_units) {
          setBusinessUnits(parsed.business_units);
        }
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to load business units');
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [githubAuth, owner, repo, path, ref]);

  return { businessUnits, loading, error };
}
